import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import jobs from "../../../data/jobs";
import JobFilter from "./JobFilter";
import ContactPage from "../../../components/Global/BannerCard/DynamicHeader/ContactPage1";

export default function CurrentOpportunities() {
  const [filters, setFilters] = useState({ type: "", location: "", search: "" });
  const [visibleCount, setVisibleCount] = useState(10);

  const filteredJobs = jobs.filter((job) => {
    return (
      (!filters.type || job.department === filters.type) &&
      (!filters.location || job.locations.includes(filters.location)) &&
      (!filters.search || job.title.toLowerCase().includes(filters.search.toLowerCase()))
    );
  });

  const handleShowMore = () => {
    setVisibleCount((prev) => prev + 10);
  };

  const handleResetAll = () => {
    setFilters({ type: "", location: "", search: "" });
    setVisibleCount(10);
  };

  return (
    <>
      <Helmet>
        <title>Adithya Infinity</title>
        <meta
          name="description"
          content="Explore exciting career opportunities at V Adithya Private Limited. Apply now to join our team and shape the future in IT, Engineering, and Non-IT roles."
        />
        <meta name="keywords" content="V Adithya Private Limited Careers, IT jobs, Non-IT jobs, Hyderabad jobs, Bangalore jobs, job openings" />
        <link rel="canonical" href="https://www.adithyainfinity.com/joblist" />

      
        <meta property="og:title" content="Current Opportunities | V Adithya Private Limited Careers" />
        <meta property="og:description" content="Discover open positions and apply to become part of the V Adithya Private Limited team." />
        <meta property="og:url" content="https://www.adithyainfinity.com/joblist" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://www.adithyainfinity.com/joblist/assets/joblist-banner.jpg" />

      
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Current Opportunities | V Adithya Private Limited Careers" />
        <meta name="twitter:description" content="Explore IT and Non-IT openings at V Adithya Private Limited and build your future with us." />
        <meta name="twitter:image" content="https://www.adithyainfinity.com/joblist/assets/jonlist-banner.jpg" />
      </Helmet>

      <ContactPage
        title="CURRENT OPPORTUNITIES"
        backgroundImage="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBw8NDw0NDQ0QDQ0NEBINDQ0NEBANDQ0NFRIWFhURFRUYHSggGBolGxUVITEhJSkrOi4uFx8/OD84Nyg5OisBCgoKDg0NFQ0NFSsZFRkrLS03LSsrKy03Ny0rKystLS03LS0rNy0tLS0tNysrLTc3Ny0tNystKy03Ny0tKy0tK//AABEIAKgBLAMBIgACEQEDEQH/xAAYAAEBAQEBAAAAAAAAAAAAAAAAAQIHA//EACYQAQAABQUAAgMBAQEAAAAAAAADMdHh8AIUQVOSARFRYcGhsSH/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhEDEQA/AOIAKKACoAigApZFsAAC3LJfktyC3Vm/LWTAuJfkr+QU+/8Av8TJrX8/oEVMmZMD7/gnxn/pkwLFyxcAABAARUAAFQBAAAAUURQAMmCiZMyYirbhMmW5BS3Bky3IBbgyZbkFvwJflcmBklyTOTWv5AyS1/jOTWv5/QGSEyZkwW3CZItyZMC3BfgtyX5AQyZkwATJgqGTBT5D5QABABAUAFEVQABRARSwW5BSxk0tyCljJluQLr9pfkyYH2qZMyYC5/iZMyf6ADJmTAsFuTJgWLluUvyCoZMyYAICoAoCIAAAICgAAAoCioAKBbkQWyZMyYKJk1yYFxL8rkwBMmuTAM/xMmuTAEya5MCwmTMmC5JDJmTADJgCAKAAICAACAAoAAAKIKKAClkAUQEUEBbqyoKIAKgAqAAAAgCoAoAAIAAIAIAioDQn2AoCgAgogCgKKgAomTAFQEUTJgKIuTAEyagCAAZMFAAEVEFQFAABPtUQQABftAGkAFAAABRAFEUAD7UFQAVAAABUAAAAQFQAAEAEBU+w+wPtAAAAABfg+EX4BRPgBRBRQEBUFFEEFEFFEEFEFFEEFEAAAAAAQFD7T7A+flFQAAAAAAAAFEAVWVBRFAAAAAAAAAAAAAAAAABAVBAUQAAAAABAURQAAAAAAFQBVZUFEAURfkARQBFAE+AFEAAAEAFQAAAAAAQAAHvs4vTE8aqGzi9MTxqoAGzi9MTxqouzi9MTxqogC7OL1RPGqhs4vTE8aqABs4vTE8aqGzi9MTxqoAGzi9MTxqobOL0xPGqgAbOL0xPGqhs4vTE8aqABs4vVE8aqGzi9UTxqoAGzi9UTxqobOL1RPGqgAbOL1RPGqhs4vVE8aqABs4vVE8aqGzi9UTxqoAGzi9UTxqobOL1RPGqgAbOL1RPGqhs4vVE8aqABs4vTE8aqGzi9MTxqoAGzi9MTxqobOL0xPGqgAbOL0xPGqhs4vTE8aqABs4vTE8aqGzi9UTxqogC7OL1RPGqibOL0xPGqgAbOL0xPGqhs4vTE8aqABs4vTE8aqGzi9MTxqoAP/9k=" 
        highlightWord="OPPORTUNITIES" />

      <div className="px-4 md:px-8 lg:px-16 py-6 bg-white min-h-screen">
        <JobFilter onFilterChange={setFilters} />

        <div className="flex justify-between items-center mb-4">
          <p className="font-semibold text-gray-700 text-sm md:text-base">
            {filteredJobs.length} openings found
          </p>
          <button
            onClick={handleResetAll}
            className="px-4 py-2 border border-blue-600 text-blue-600 rounded hover:bg-blue-600 hover:text-white transition text-sm"
          >
            Reset All
          </button>
        </div>

        <div className="space-y-4">
          {filteredJobs.length > 0 ? (
            filteredJobs.slice(0, visibleCount).map((job) => (
              <div
                key={job.id}
                className="flex flex-col md:flex-row justify-between items-start md:items-center p-4 border rounded-md shadow-sm hover:shadow-md transition bg-gray-50"
              >
                <div className="mb-4 md:mb-0">
                  <Link to={`/careers/job-details/${job.id}`}>
                    <h3 className="text-lg md:text-xl font-semibold text-blue-600 hover:underline">
                      {job.title}
                    </h3>
                  </Link>
                  <p className="text-gray-700 text-sm">
                    {job.designation} | {job.locations[0]} | {job.experience}
                  </p>
                  <p className="text-sm text-gray-600">
                    {job.department} | Posted on: {job.postedDate}
                  </p>
                </div>
                <Link to={`/careers/job-details/${job.id}`}>
                  <button className="px-4 py-2 border border-blue-600 text-blue-600 rounded hover:bg-blue-600 hover:text-white transition text-sm">
                    Apply
                  </button>
                </Link>
              </div>
            ))
          ) : (
            <p className="text-center text-red-600 font-semibold">
              No jobs match your filters.
            </p>
          )}
        </div>

        {visibleCount < filteredJobs.length && (
          <div className="flex justify-center mt-8">
            <button
              onClick={handleShowMore}
              className="px-6 py-2 bg-teal-600 text-white rounded hover:bg-teal-700 transition"
            >
              Show More
            </button>
          </div>
        )}
      </div>
    </>
  );
}
